import React from 'react';

import ContentfulImage from '../../Common/ContentfulImage';
import SmartLink from '../../Common/SmartLink';
import * as ds from './DesktopStyles.module.css';
import * as styles from './Header.module.css';
import OptionalNav from './OptionalNav';

const ListLink = ({ sub, dark }) => (
  <div key={sub.title} className={ds.linkRow}>
    <ContentfulImage className={styles.svgImg} imageFragment={sub.icon} />
    &nbsp;&nbsp;
    <SmartLink to={sub.url} className={[styles.menuItemLink, ds.menuItemLink, dark ? styles.darkFix : ''].join(' ')}>
      {sub.title}
      <p className={styles.itemDesc}>{sub.description}</p>
    </SmartLink>
  </div>
);

const SubMenuColumns = ({ item, subNav, optionalNav, imgLocation, dark }) => {
  const topLevelColumn = subNav.filter((s) => !s.subMenuItems || s.subMenuItems.length === 0);
  const sections = subNav.filter((s) => s.subMenuItems && s.subMenuItems.length > 0);
  return (
    <div className={ds.subNav}>
      {item.titleUrl && (
        <SmartLink to={item.titleUrl} className={ds.rowColumnHead}>
          <div className={ds.sectionTitle}>{item.sectionTitle}</div>
          <div className={ds.sectionDesc}>{item.description ? item.description.description : ''}</div>
        </SmartLink>
      )}
      {!item.titleUrl && (
        <>
          <div className={ds.sectionTitle}>{item.sectionTitle}</div>
          <div className={ds.sectionDesc}>{item.description ? item.description.description : ''}</div>
        </>
      )}
      <hr />
      <div className={ds.horiList}>
        <div className={ds.stackedColumns}>
          <div className={ds.sectionCol}>
            {topLevelColumn.map((sub, s) => {
              const childlink = <ListLink sub={sub} key={s} dark={dark} />;
              return (
                <li
                  className={[styles.menuItem, ds.menuItem, dark ? styles.darkFix : ''].join(' ')}
                  key={`${sub.title}-${s}`}
                >
                  {childlink}
                </li>
              );
            })}
          </div>
          {sections.map((section, k) => (
            <div className={ds.sectionCol} key={`${section.title}-${k}-wrapper`}>
              <li
                className={[styles.menuItem, ds.menuItem, dark ? styles.darkFix : ''].join(' ')}
                key={`${section.title}-${k}`}
              >
                <div className={[ds.linkRow, ds.menuTitle].join(' ')}>{section.title}</div>
              </li>
              {section.subMenuItems.map((subItem, j) => (
                <li
                  className={[styles.menuItem, ds.menuItem, dark ? styles.darkFix : ''].join(' ')}
                  key={`${subItem.title}-${j}`}
                >
                  <ListLink sub={subItem} dark={dark} />
                </li>
              ))}
            </div>
          ))}
        </div>
        <OptionalNav optionalNav={optionalNav} imgLocation={imgLocation} />
      </div>
    </div>
  );
};

SubMenuColumns.propTypes = {
  // myProp: PropTypes.string.isRequired
};

export default SubMenuColumns;
